<!-- 商务经理视图 -->
<template>
  <div class="businessManager">
    <div class="container">
      <div class="up">
        <div class="clue_count">
          <div class="clue_count_left">
            <div class="pic_box">
              <img src="../../../assets/logo.png" alt="头像" />
            </div>
            <span class="name">Amy</span>
          </div>
          <div class="clue_count_center">
            <div style="margin-bottom: 20px">
              <span>我的项目</span>
            </div>
            <div>
              <span class="number">30</span>
            </div>
            <div>
              <el-button size="mini" type="primary">查看所有</el-button>
            </div>
          </div>
          <div id="main" class="clue_count_right"></div>
        </div>
        <div class="message_inform">
          <div class="title">
            <span>消息通知</span>
            <div class="icon">
              <div class="item" v-for="(item, index) in 3" :key="index"></div>
            </div>
          </div>
          <div class="context">
            <div class="message_item" v-for="(item, index) in 3" :key="index">
              <div class="time txt">
                <span>2022-08-25</span>
              </div>
              <div class="message txt">
                <span>Andrew您好，客户中心有新增，需要您去分配新的客户经理</span>
              </div>
              <div class="examine">
                <span>未读</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="down">
        <div>
          <i></i>
          <h3 style="font-size: 18px">工作统计</h3>
        </div>
        <div>
          <table>
            <tr>
              <th></th>
              <th>当周</th>
              <th>上周</th>
            </tr>
            <tr v-for="(item, index) in tableData" :key="index">
              <td>
                <div class="column1">{{ item.value }}</div>
              </td>
              <td>
                <div class="column2">{{ item.thisWeek }}</div>
              </td>
              <td>
                <div class="column3">{{ item.lastWeek }}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      //表格数据
      tableData: [
        {
          value: '总线索',
          thisWeek: 1,
          lastWeek: 2
        },
        {
          value: '总线索',
          thisWeek: 1,
          lastWeek: 2
        },
        {
          value: '总线索',
          thisWeek: 1,
          lastWeek: 2
        },
        {
          value: '总线索',
          thisWeek: 1,
          lastWeek: 2
        },
        {
          value: '总线索',
          thisWeek: 1,
          lastWeek: 2
        },
        {
          value: '总线索',
          thisWeek: 1,
          lastWeek: 2
        }
      ]
    }
  },
  computed: {},
  watch: {},
  methods: {
    drawChart() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById('main'))
      // 指定图表的配置项和数据
      let option = {
        color: [
        '#17757A;'
        ],
        tooltip: {},
        legend: {
          data: ['销量']
        },
        xAxis: {
          data: ['进行中', '已完成', '已结束', '已冻结']
        },
        yAxis: {
          //axisTick:false
        },
        series: [
          {
            type: 'bar',
            data: [32, 20, 21, 41],
          }
        ]
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
    }
  },
  created() {},
  mounted() {
    this.drawChart()
  }
}
</script>
<style scoped lang="less">
.container {
  width: 100%;
  overflow: scroll;
}
.up {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-bottom: 20px;
  .clue_count {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 50%;
    margin-right: 20px;
    padding: 0 40px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 8px;
    .clue_count_left {
      display: flex;
      align-items: center;
      width: 20%;
      min-width: 100px;
      .pic_box {
        overflow: hidden;
        width: 56px;
        height: 56px;
        margin-right: 10px;
        background-color: #999;
        border-radius: 50%;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .clue_count_center {
      display: flex;
      flex-flow: column;
      align-items: center;
      min-width: 120px;
      width: 20%;
      .number {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
      }
    }
    .clue_count_right {
      flex: 1;
      height: 100%;
      min-width: 200px;
      padding: 10px;
      box-sizing: border-box;
    }
  }
  .message_inform {
    flex: 1;
    background-color: #fff;
    border-radius: 8px;
    padding-left: 23px;
    padding-top: 24px;
    box-sizing: border-box;
    border-radius: 8px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-width: 80px;
      font-size: 20px;
      font-weight: bold;
      color: #06152b;
      margin-bottom: 40px;
      padding: 0 20px 0 0;
      .icon {
        width: 18px;
        height: 4px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        .item {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #6b738d;
        }
      }
    }
    .context {
      .message_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 95%;
        height: 40px;
        background-color: #f6f7f7;
        border-radius: 2px;
        margin-bottom: 6px;
        padding-right: 10px;
        .txt {
          min-width: 100px;
          color: #06152b;
          font-size: 16px;
          span {
            overflow: hidden;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            white-space: nowrap;
            height: 24px;
            display: block;
          }
        }
        .message {
          width: 75%;
          overflow: hidden;
          margin-left: 15px;
        }
        .examine {
          width: 32px;
          height: 24px;
          background-color: #ff7676;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          font-size: 10px;
        }
      }
    }
  }
}
.down {
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 30px;
  table {
    margin: 30px;
    border-collapse: collapse; //表格的边框合并，如果相邻，则共用一个边框。
    border-spacing: 0; //设置行与单元格边框的间距。
    th {
      height: 50px;
      min-width: 200px;
      background: #f4f7f9;
      margin: 0;
    }
    td {
      height: 40px;
      text-align: center;
      line-height: 40px;
    }
    .column1 {
      height: 100%;
      background: #f4f7f9;
      border-right: #e4eef6 1px solid;
      border-bottom: #e4eef6 1px solid;
    }
    .column2,
    .column3 {
      height: 100%;
      border-right: #e4eef6 1px solid;
      border-bottom: #e4eef6 1px solid;
    }
  }
}

table tr:first-child th:first-child {
  border-top-left-radius: 10px; /* 设置table左上圆角 */
}
table tr:first-child th:last-child {
  border-top-right-radius: 10px; /* 设置table右上圆角 */
}
table tr:last-child td:first-child {
  border-bottom-left-radius: 10px; /* 设置table左下圆角 */
}
table tr:last-child td:last-child {
  border-bottom-right-radius: 10px; /* 设置table右下圆角 */
}
</style>
